<template>
  <div class="min-h-screen bg-[#0F0F0F] text-white py-10 px-4 md:px-10">
    <div
      class="max-w-4xl mx-auto bg-[#1F1F1F] p-8 rounded-2xl shadow-xl border border-gray-700"
    >
      <h1 class="text-3xl md:text-4xl font-bold text-center mb-8">
        {{ $t("legal.title") }}
      </h1>

      <div class="space-y-6 text-gray-300 text-sm leading-relaxed">
        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.owner.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("legal.sections.owner.text1") }}
            <b class="text-white">{{ $t("legal.sections.owner.brand") }}</b>
            {{ $t("legal.sections.owner.text2") }}
            <b class="text-white">{{ $t("legal.sections.owner.owner") }}</b>
            {{ $t("legal.sections.owner.text3") }}
            <a
              :href="`mailto:info@mem22.com`"
              class="underline text-blue-400 hover:text-blue-300"
            >
              info@mem22.com
            </a>
            {{ $t("legal.sections.owner.text4") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.copyright.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("legal.sections.copyright.text1") }}
            <b class="text-white">{{ $t("legal.sections.copyright.brand") }}</b>
            {{ $t("legal.sections.copyright.text2") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.responsibility.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("legal.sections.responsibility.content") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.membership.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("legal.sections.membership.text1") }}
            <b class="text-white">{{
              $t("legal.sections.membership.brand")
            }}</b>
            {{ $t("legal.sections.membership.text2") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.thirdParty.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("legal.sections.thirdParty.text1") }}
            <b class="text-white">{{
              $t("legal.sections.thirdParty.brand")
            }}</b>
            {{ $t("legal.sections.thirdParty.text2") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.jurisdiction.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            {{ $t("legal.sections.jurisdiction.text1") }}
            <b class="text-white">{{
              $t("legal.sections.jurisdiction.brand")
            }}</b>
            {{ $t("legal.sections.jurisdiction.text2") }}
          </p>
        </section>

        <section>
          <h2 class="text-xl font-semibold text-white mb-2">
            {{ $t(`legal.sections.updates.title`) }}
          </h2>
          <p class="text-sm text-gray-400 leading-relaxed">
            <b class="text-white">{{ $t("legal.sections.updates.brand") }}</b>
            {{ $t("legal.sections.updates.text1") }}
          </p>
        </section>

      </div>

      <div class="mt-10 text-center text-gray-500 text-xs">
        © {{ new Date().getFullYear() }} MEM22 Akademi. Tüm hakları saklıdır.
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
definePageMeta({ layout: "default" });
</script>
